const styles = theme => ({
  rootTableCell: {
    backgroundColor: '#F4F6F8',
    width: '20%', // Each column width 25%
    textAlign: 'center',
  },
  rootTableCell2: {
    backgroundColor: '#F4F6F8',
    width: '40%', // Name cell width 50%
    fontSize: '14px',
  },
  tableBox: {
    width: 24,
    height: 24,
    color: '#015FFB',
  },
})

export default styles
